// 1. Import supabase instead of firebase
// Make sure this path points to where you created your supabaseClient file
import { supabase } from '../supabaseClient'; 

let storedGuestId = null;
let storedGuestName = "Guest";

// 2. Local variable to hold the user (mimics Firebase's synchronous behavior)
let currentUser = null;

// 3. Listener: Automatically updates 'currentUser' whenever Auth state changes
// This ensures getCurrentUserId() works instantly without needing 'await'
supabase.auth.onAuthStateChange((event, session) => {
  currentUser = session?.user || null;
});

export function setGuestInfo(id, name) {
  storedGuestId = id;
  storedGuestName = name;
}

export function getCurrentUserId() {
  // Check the local Supabase user variable
  if (currentUser) return currentUser.id;
  
  return storedGuestId;
}

export function getCurrentUserName() {
  if (currentUser) {
    // CHANGE: Supabase stores names in 'user_metadata', not 'displayName'
    // We check full_name (which we set in signup), then email, then default
    return currentUser.user_metadata?.full_name || currentUser.email || "User";
  }
  return storedGuestName;
}

export function getUserData() {
  let myUserId = getCurrentUserId();
  let myUserName = getCurrentUserName();

  return { myUserId, myUserName };
}